import utils from '../../../../../utils';
export function getCsvContent(workspace, path, startIndex, rowLimit) {
  return utils.request({
    url: '/backend/csvdata',
    query: {
      workspace: workspace,
      path: path,
      startIndex: startIndex,
      rowLimit: rowLimit
    }
  });
}
export function saveCsvContent(workspace, path, data) {
  return utils.request({
    method: 'PUT',
    url: '/backend/csvdata',
    query: {
      workspace: workspace,
      path: path
    },
    data: data
  });
}